import { atom } from 'recoil';

import { localStorage } from '@gitbook/util-local-storage';

/**
 * Default prompted merge strategy.
 */
export const mergeStrategyAtom = atom<'merge' | 'ready-for-review'>({
    key: 'mergeStrategy',
    default: 'merge',
    effects: [localStorage.recoilEffect('@recoil/mergeStrategy', 'merge')],
});
